import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import store from "@/store"
import {IdMapper} from "@/interfaces/state/base";
import {PaginationMeta} from "@/interfaces/common";
import {ManageFeeParams} from "@/modules/managefeecustomer/params";
import {
    listDebtsDetailPayedManageFee,
    listNotYetPayManageFee,
    listPayedManageFee
} from "@/modules/managefeecustomer/services";
import {getDataSequentially} from "@/shared/services/helper/utils";

@Module({ dynamic: true, name: "manageFeeStore", store })
class ManageFeeModule extends VuexModule {
    payedData: IdMapper<any> = {};
    payedIds: number[] = [];
    payedMeta: PaginationMeta = new PaginationMeta();
    payedParams: ManageFeeParams = new ManageFeeParams();
    debtsOfPayed = [] as any;

    notPayData: IdMapper<any> = {};
    notPayIds: number[] = [];
    notPayMeta: PaginationMeta = new PaginationMeta();
    notPayParams: ManageFeeParams = new ManageFeeParams();
    notPayDataExcel = [] as any;


    @Mutation
    private MAP_PAYED_MANAGE_FEE_LIST(payload: any) {
        const idMapper = {} as any;
        this.payedMeta = payload.meta;
        this.payedIds = payload.datas?.map((data: any, index: number) => {
            idMapper[data.id] = {...data, stt: index + 1};
            return data.id;
        });
        this.payedData = idMapper;
    }

    @Mutation
    private MAP_NOT_PAY_MANAGE_FEE_LIST(payload: any) {
        const idMapper = {} as any;
        this.notPayMeta = payload.meta;
        this.notPayIds = payload.datas?.map((data: any, index: number) => {
            idMapper[data.rowGuid] = {...data, stt: index + 1};
            return data.rowGuid;
        });
        this.notPayData = idMapper;
    }

    @Mutation
    private UPDATE_PAYED_MANAGE_FEE_PARAMS(payload: any) {
        this.payedParams = payload;
    }

    @Mutation
    private UPDATE_NOT_PAY_MANAGE_FEE_PARAMS(payload: any) {
        this.notPayParams = payload;
    }

    @Mutation
    private UPDATE_DEBTS_OF_PAYED(payload: any) {
        this.debtsOfPayed = payload;
    }

    @Mutation
    private UPDATE_NOT_PAY_DATA_EXCEL(payload: any) {
        this.notPayDataExcel = payload;
    }

    @Mutation
    private UPDATE_PAYED_DATA_EXCEL(payload: any) {
        this.debtsOfPayed = payload;
    }

    @Action({ rawError: true })
    public async listPayedManageFee(params: any) {
        const { data } = await listPayedManageFee(params);
        this.MAP_PAYED_MANAGE_FEE_LIST(data);
    }

    @Action({ rawError: true })
    public async listDebtsDetailPayedManageFee(params: any) {
        this.UPDATE_DEBTS_OF_PAYED([]);
        const data = await getDataSequentially(listDebtsDetailPayedManageFee, params);
        this.UPDATE_DEBTS_OF_PAYED(data);
    }

    @Action({ rawError: true })
    public async listNotPayManageFee(params: any) {
        const { data } = await listNotYetPayManageFee(params);
        this.MAP_NOT_PAY_MANAGE_FEE_LIST(data);
    }

    @Action({ rawError: true })
    public updatePayedParams(payload: any) {
        this.UPDATE_PAYED_MANAGE_FEE_PARAMS(payload);
    }

    @Action({ rawError: true })
    public async paramPayedManageFeeChange(params: any) {
        this.updatePayedParams(params);
        await this.listPayedManageFee(params);
    }

    @Action({ rawError: true })
    public updateNotPayParams(payload: any) {
        this.UPDATE_NOT_PAY_MANAGE_FEE_PARAMS(payload);
    }

    @Action({ rawError: true })
    public async paramNotPayManageFeeChange(params: any) {
        this.updateNotPayParams(params);
        await this.listNotPayManageFee(params);
    }

    @Action({ rawError: true })
    public async exportExcelNotPay(params: any) {
        this.UPDATE_NOT_PAY_DATA_EXCEL([]);
        const data = await getDataSequentially(listNotYetPayManageFee, params);
        this.UPDATE_NOT_PAY_DATA_EXCEL(data);
    }

    @Action({ rawError: true })
    public async exportExcelPayed(params: any) {
        this.UPDATE_PAYED_DATA_EXCEL([]);
        const data = await getDataSequentially(listPayedManageFee, params);
        this.UPDATE_PAYED_DATA_EXCEL(data);
    }
}

export const ManageFeeStore = getModule(ManageFeeModule);
